export default "__VITE_ASSET__BmD6oaD3__"